<div class="case-feature-preview">
  <div class="case-feature-preview__toolbar" *ngIf="events().length">
    <ui-search
      class="case-feature-preview__search"
      [placeholder]="'SEARCH_GLOBAL_MODAL.SEARCH_EVENTS' | translate"
      [searchQuery]="searchTerm()"
      [heightPx]="40"
      (onInput)="searchTerm.set($event)"
    ></ui-search>
  </div>

  <div class="case-feature-preview__body">
    <div *ngIf="isLoading(); else eventsContent" class="case-feature-preview__loader">
      <ui-preloader [color]="preloaderColor"></ui-preloader>
    </div>

    <ng-template #eventsContent>
      <div *ngIf="filteredEvents().length; else noEvents" class="case-feature-list">
        <div
          *ngFor="let event of filteredEvents()"
          class="case-feature-card case-feature-card--clickable"
          (click)="openEvent(event)"
        >
          <div class="case-feature-card__content">
            <div class="case-feature-card__header">
              <div class="case-feature-card__title" [title]="event.eventName">
                <span class="ui-icon-notifications"></span>
                {{ event.eventName }}
              </div>
            </div>

            <div class="case-feature-card__meta">
              <span class="ui-icon-time"></span>
              <span>{{ event.timestamp | date: 'MMM d, y, h:mm:ss a' }}</span>
            </div>

            <div *ngIf="event.userName" class="case-feature-card__meta">
              <span class="ui-icon-user"></span>
              <span>{{ event.userName }}</span>
            </div>

            <div *ngIf="event.site || event.device" class="case-feature-card__meta">
              <span class="ui-icon-location"></span>
              <span>{{ event.site }}{{ event.site && event.device ? ' | ' : '' }}{{ event.device }}</span>
            </div>

            <div *ngIf="event.lastComment" class="case-feature-card__meta">
              <span class="ui-icon-comment"></span>
              <span>{{ event.lastComment }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>

    <ng-template #noEvents>
      <div class="case-feature-preview__empty">
        <span class="case-feature-preview__empty-icon ui-icon-notifications"></span>
        <div>{{ 'CONTROL_EVENTS.NO_DATA.TITLE' | translate }}</div>
      </div>
    </ng-template>
  </div>
</div>
